import { createContext, useContext } from "react";

import type { CareplanModel } from "@/domains/careplan/models/types";

export const CareplanContext = createContext<CareplanModel | null>(null);

export const useCareplanContext = () => {
  const careplan = useContext(CareplanContext);

  if (!careplan) {
    throw Error("useCareplanContext can only be used inside a CareplanContext.Provider");
  }

  return careplan;
};
